var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-configuration"},[(_vm.canAdd)?_c('button',{staticClass:"empty-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('add')}}},[_vm._v("+")]):_vm._e(),_c('h4',[_vm._v("No configuration available")]),_c('p',[_vm._v(_vm._s(_vm.emptyMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }